import { LAYOUT_COMPONENT_TYPE, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const heroEditorialDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.hero,
  componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
  displayOrder: 1,
  content: {
    eyebrow: loc3('Seit 1987 · Norditalienisch', 'Est. 1987 · Northern Italian', 'Từ 1987 · Bắc Ý'),
    heading: loc3(
      'Saisonale Küche, Abende bei Kerzenlicht',
      'Seasonal cuisine, candlelit evenings',
      'Ẩm thực theo mùa, buổi tối ánh nến',
    ),
    subheading: loc3(
      'Handgemachte Pasta und eine Weinliste für jeden Gang.',
      'Hand-rolled pasta and a wine list curated for every course.',
      'Mì handmade và danh sách rượu được chọn cho từng món.',
    ),
    ctaPrimary: loc3('Tisch reservieren', 'Reserve a table', 'Đặt bàn'),
    ctaSecondary: loc3('Speisekarte ansehen', 'View menu', 'Xem thực đơn'),
  },
  media: {
    heroImage:
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&h=900&fit=crop',
  },
};

export const heroEditorialLongHeadline: LayoutBlock = {
  ...heroEditorialDefault,
  blockId: 'a1000002-0002-4002-8002-000000000099',
  content: {
    ...heroEditorialDefault.content,
    heading: loc3(
      'Eine außergewöhnlich lange Überschrift zum Testen von Zeilenumbruch und typografischer Skala in allen Themes',
      'An extraordinarily long headline to stress-test wrapping, balance, and typographic scale across every theme and colorset in the layout matrix',
      'Tiêu đề cực dài để kiểm tra xuống dòng, cân bố cục và tỷ lệ chữ trên mọi theme và colorset trong ma trận layout',
    ),
  },
};
